import React from 'react';

export function Rating({rating}) {
    const stars = [];
    for (let i = 0, l = rating; i < l; ++i) {
        stars.push(
            <i key={i} className="icon-star" />,
        );
    }

    return (
        <div className="hotel__info_rating flex items-center gap-x-1 absolute top-4 right-4 text-[12px] text-orange sm:top-0 sm:right-0 sm:text-[14px]">
            {stars}
        </div>
    );
}
